import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import PayloftLogo from "../assets/images/payloft-logo.png";
import toast from "react-hot-toast";
import { NewMemberInvite, RetrieveNewUser } from "../services/settings";

const CreateAccount = () => {
  const email = useParams();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);
  const [decodeEmail, setDecodeEmail] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [passwordError, setPasswordError] = useState(""); // State for password error message
  const navigate = useNavigate();

  useEffect(() => {
    const decodedEmail = atob(email.email);
    setDecodeEmail(decodedEmail);
    setIsLoading(false);
  }, [email.email]);

  const handleShowNew = (e) => {
    e.preventDefault();
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    // Validate password
    try {
      validatePassword(newPassword);
      setPasswordError(""); // Clear error message if validation passes
    } catch (error) {
      setPasswordError(error.message); // Set error message if validation fails
    }
  };

  const handleCreateAccount = async (e) => {
    e.preventDefault();

    try {
      // Validate password again before submission
      validatePassword(password);

      const response = await NewMemberInvite({
        emailAddress: decodeEmail,
        firstName: firstName,
        lastName: lastName,
        password: password,
        address: address,
        phoneNumber: phoneNo,
      });
      toast.success(response.message);
      navigate("/");
    } catch (error) {
      setPasswordError(error.message);
    }
  };

  // Function to validate password
  const validatePassword = (password) => {
    // Regular expressions for validation
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    // Check password length, presence of number, and special character
    if (
      password.length < 9 ||
      !hasNumber.test(password) ||
      !hasSpecialChar.test(password)
    ) {
      throw new Error(
        "Password must be at least 9 characters long and contain a number and a special character."
      );
    }
  };

  return (
    <div className="flex justify-center">
      <div className="w-[448px] p-4">
        <div className="flex items-center justify-center">
          <img
            src={window.__TENANT__?.logo ?? PayloftLogo}
            alt="logo"
            className="w-[92px] h-[92px]"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-20 text-center mt-20">
          Create Account
        </h1>
        <div className="flex flex-col">
          <form onSubmit={handleCreateAccount}>
            <div className="flex flex-col mt-8">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                placeholder="example@gmail.com"
                value={decodeEmail}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8">
              <label htmlFor="firstname">First Name</label>
              <input
                type="text"
                id="firstname"
                placeholder="anthony"
                // value={firstname}
                onChange={(e) => setFirstName(e.target.value)}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8">
              <label htmlFor="lastname">Last Name</label>
              <input
                type="text"
                id="lastname"
                placeholder="chukwuma"
                // value={email}
                onChange={(e) => setLastName(e.target.value)}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8 relative">
              <label htmlFor="password">Password</label>
              <button
                onClick={handleShowNew}
                className="absolute right-4 top-12"
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </button>
              <input
                type={inputPassNew}
                id="password"
                placeholder="...."
                value={password}
                onChange={
                  handlePasswordChange
                } /* Updated to handlePasswordChange */
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
              {passwordError && (
                <span className="text-xs text-red-500">{passwordError}</span>
              )}{" "}
              {/* Display password error */}
            </div>
            <div className="flex flex-col mt-8">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                id="address"
                placeholder="address"
                // value={email}
                onChange={(e) => setAddress(e.target.value)}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8">
              <label htmlFor="phonenumber">Phone Number</label>
              <input
                type="number"
                id="phonenumber"
                placeholder="07083225145"
                // value={email}
                onChange={(e) => setPhoneNo(e.target.value)}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>

            <div className="mt-10">
              <button
                disabled={passwordError}
                className="bg-primary w-[410px] h-[50px] text-white rounded-md cursor-pointer disabled:bg-[rgba(var(--primary-rgb),0.3)]"
                type="submit"
              >
                Create Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
